const DynamicElectionRoutes = function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("dynamicElection", {
        url: "/elections/*name",
        controller: "DynamicElectionRoutingController",
        templateUrl: function (params) {
            const dirPath = params.name;
            const dirs = dirPath.split("/");
            const url = __styleEnv__ + "customizations/Default/elections/" + dirs[0] + ".html";
            return url;
        },
        data: {
            fullHeight: true,
            title: "dynamic"
        }
    });
};

DynamicElectionRoutes.$inject = ["$stateProvider", "$urlRouterProvider"];
export default DynamicElectionRoutes;
